import { useEffect } from 'react';
import { trackChatOpened } from '../../../helpers/posthogAnalytics';
import { startChatSessionRecording } from '../../../helpers/posthogManager';

/**
 * Custom hook that starts the PostHog session recording once the visitor
 * opens the Digital Chat, so replays only cover sessions with the chat open.
 *
 * The chat runs in a cross-origin iframe (embed.js in public/index.html) that
 * posts { type: "wah-chat-resize", open } to this window on every open/close.
 */
const useTrackChatOpened = () => {
  useEffect(() => {
    let chatOrigin;
    try {
      chatOrigin = new URL(process.env.REACT_APP_DIGITAL_CHAT_WIDGET_URL).origin;
    } catch (e) {
      return;
    }

    const handleMessage = (event) => {
      if (event.origin !== chatOrigin) return;
      if (event.data?.type !== 'wah-chat-resize' || !event.data.open) return;

      startChatSessionRecording();
      trackChatOpened();
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);
};

export default useTrackChatOpened;
